import { Grid } from 'antd';

/**
 * True when the viewport is below Ant's `md` breakpoint (768px).
 *
 * Uses `=== false` rather than `!screens.md` so the pre-resolution render
 * (where `screens.md` is `undefined`) is treated as **desktop**, avoiding a
 * desktop→mobile first-paint flash.
 */
export const useIsMobile = (): boolean => Grid.useBreakpoint().md === false;
